/**
 * Runtime API configuration — domain-agnostic.
 * 
 * Uses relative URLs so the app works on any domain
 * without rebuilding. The Kubernetes ingress routes
 * /api/* to the backend automatically.
 */

// Empty string = relative URL (same domain)
export const API_BASE = '';

// WebSocket base URL derived from current page location
export const WS_BASE = typeof window !== 'undefined'
  ? `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`
  : '';
